import { render, staticRenderFns } from "./SessionFiles.vue?vue&type=template&id=4aef36f9&scoped=true&lang=pug"
import script from "./SessionFiles.vue?vue&type=script&lang=js"
export * from "./SessionFiles.vue?vue&type=script&lang=js"
import style0 from "./SessionFiles.vue?vue&type=style&index=0&id=4aef36f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aef36f9",
  null
  
)

export default component.exports